import {
  computeDocumentTotals,
  computeLineItemSubtotal,
  type DocumentDiscountType,
  type InvoiceTaxType,
} from '@trellis/shared'
import { useMemo } from 'react'

import { getCurrencyFormatter } from '@/lib/format'
import type { LineItemRowValue } from '@/pages/invoices/(components)/LineItemRow'

export function useDocumentTotals(
  lineItems: LineItemRowValue[],
  taxType: InvoiceTaxType,
  taxRate: number,
  currency: string,
  discount: number,
  discountType: DocumentDiscountType,
) {
  const { subtotal, discountAmount, taxAmount, total } = useMemo(() => {
    const itemSubtotals = lineItems.map((lineItem) => {
      const unitPrice = isNaN(lineItem.unitPrice) ? 0 : lineItem.unitPrice
      const quantity = isNaN(lineItem.quantity) ? 0 : lineItem.quantity
      return {
        subtotal: computeLineItemSubtotal(
          unitPrice,
          quantity,
          isNaN(lineItem.discount) ? 0 : lineItem.discount,
          lineItem.discountType,
        ),
        taxable: lineItem.taxable,
      }
    })

    return computeDocumentTotals(
      itemSubtotals,
      taxType !== 'NONE' ? taxRate / 100 : 0,
      isNaN(discount) ? 0 : discount,
      discountType,
    )
  }, [lineItems, taxType, taxRate, discount, discountType])

  const currencyFormatter = getCurrencyFormatter(currency)

  return {
    subtotal,
    discountAmount,
    taxAmount,
    total,
    currencyFormatter,
  }
}
